import { get } from 'lodash';
import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import PatientMeeting from './component';

export default connect((state) => ({
  attendeeGuid: get(state, ['Location', 'payload', 'attendee_guid']),
}), (dispatch) => ({
  meetingEndAndPatientToComplete: () => dispatch(actions.meetingEndAndPatientToComplete()),
}))(PatientMeeting);
